<template>
  <div>
    <HomeInicio />
    
    <div class="container" v-if="paquete === 4">
      <h2>Mi álbum de fotos</h2>

      <button v-if="fotos.length > 0" @click="eliminarFotos" class="eliminar-btn">
        Eliminar
      </button>

      <div v-if="fotos.length > 0" class="gallery-container">
        <div class="gallery">
          <div v-for="foto in fotos" :key="foto.id_subirfotos" class="photo-card">
            <!-- Forzar descarga al hacer clic -->
            <a :href="foto.url_foto" download>
              <img
                :src="foto.url_foto"
                alt="Foto"
                class="photo"
                @click.prevent="abrirModal(foto)"
              />
            </a>
          </div>
        </div>
      </div>

      <div v-else class="nodisponible">
        <p>No hay fotos disponibles</p>
      </div>
    </div>

    <div v-else class="nodisponible2">
      <div class="contenedornodisp">
        <p>Esta sección no está disponible en el paquete contratado.</p>
      </div>
    </div>

    <!-- Modal -->
    <div v-if="modalAbierto" class="modal" @click="cerrarModal">
      <div class="modal-content" @click.stop>
        <span @click="cerrarModal" class="close">&times;</span>

        <!-- Enlace de descarga para la imagen -->
          <!-- Enlace de descarga para la imagen -->
          <a :href="fotoActual.url_foto" download class="download-btn">
          Descargar
        </a>
        <img :src="fotoActual.url_foto" alt="Foto grande" class="foto-modal" />

        
        <button @click="anteriorFoto" class="prev">&#10094;</button>
        <button @click="siguienteFoto" class="next">&#10095;</button>
      </div>
    </div>
  </div>
</template>


<script>
import fotosUrl from "../api";
import HomeInicio from "@/components/HomeInicio.vue";
import Swal from "sweetalert2"; // Importamos SweetAlert2

export default {
  name: "album-fotos",
  components: {
    HomeInicio,
  },
  data() {
    return {
      fotos: [],
      paquete: Number(localStorage.getItem('paquete')), // Recupera el paquete de localStorage
      fotoActual: null, // Foto actual que se muestra en el modal
      modalAbierto: false, // Controla si el modal está abierto o cerrado
    };
  },
  mounted() {
    this.obtenerFotos();
  },
  methods: {
    abrirModal(foto) {
      this.fotoActual = foto; // Establece la foto seleccionada como foto actual
      this.modalAbierto = true; // Abre el modal
    },
    descargarFoto(url) {
      const link = document.createElement("a");
      link.href = url;
      link.download = this.obtenerNombreArchivo(url);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    cerrarModal() {
      this.modalAbierto = false; // Cierra el modal
    },

    siguienteFoto() {
      const indexActual = this.fotos.indexOf(this.fotoActual);
      const siguienteIndex = (indexActual + 1) % this.fotos.length;
      this.fotoActual = this.fotos[siguienteIndex];
    },

    anteriorFoto() {
      const indexActual = this.fotos.indexOf(this.fotoActual);
      const anteriorIndex = (indexActual - 1 + this.fotos.length) % this.fotos.length;
      this.fotoActual = this.fotos[anteriorIndex];
    },

    async obtenerFotos() {
      try {
        const idFestejada = localStorage.getItem("id_festejada");
        if (idFestejada) {
          const response = await fetch(`${fotosUrl}/api2/subirfotos?id_festejada=${idFestejada}`);
          const data = await response.json();
          this.fotos = data;
        } else {
          console.error("No se encontró el id_festejada en el almacenamiento.");
        }
      } catch (error) {
        console.error("Error al obtener fotos:", error);
      }
    },
 
    obtenerNombreArchivo(url) {
      return url.split("/").pop(); // Extrae el nombre del archivo desde la URL
    },
    async eliminarFotos() {
      // Confirmación con SweetAlert2
      const confirmacion = await Swal.fire({
        title: '¿Estás seguro?',
        text: "¡No podrás revertir esta acción!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar todo!',
        cancelButtonText: 'Cancelar'
      });

      if (confirmacion.isConfirmed) {
        try {
          // Eliminar todas las fotos del backend
          const idFestejada = localStorage.getItem("id_festejada");
          console.log("ID Festejada enviado:", idFestejada); // Log para verificar que se obtiene correctamente

          if (idFestejada) {
            for (const foto of this.fotos) {
              console.log(JSON.stringify(foto)); // Esto te permitirá ver el contenido real de cada objeto foto
              await fetch(`${fotosUrl}/api2/eliminarFotos?id_festejada=${idFestejada}`, {
                method: "DELETE",
              });
            }
            // Actualizar el arreglo de fotos tras la eliminación
            this.fotos = [];
            Swal.fire(
              'Eliminado!',
              'Todas las fotos han sido eliminadas.',
              'success'
            );
          } else {
            console.error("No se encontró el id_festejada en el almacenamiento.");
          }
        } catch (error) {
          console.error("Error al eliminar fotos:", error);
          Swal.fire(
            'Error!',
            'Hubo un problema al eliminar las fotos.',
            'error'
          );
        }
      }
    },
  },
};
</script>


<style scoped>
  body {
    margin: 0;
    padding: 0;
    width: 100%;
    font-family: "Poppins", sans-serif;
    background-color: #fdfcfa;
  }
/* Contenedor principal */
.container {
  position: relative;
  width: 100%;
  margin-top: -80px;
  padding: 0;
  box-sizing: border-box;
  overflow: auto;
}
.contenedornodisp {
  position: relative;
  width: 100%;
  margin-top: 170px;
  padding: 0;
  box-sizing: border-box;
  overflow: auto;
}
.nodisponible2 {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  margin-top: 280px;
  padding: 0px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

h2 {
  font-family: 'serenety', cursive;
    font-size: 48px;
    color: #4a3f42;
    font-weight: 500;

  margin-bottom: 20px;
}

/* Contenedor con desplazamiento */
.gallery-container {
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0px;
}

/* Galería de imágenes */
.gallery {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 5px;
}

/* Tarjeta de foto */
.photo-card {
  position: relative;
  background: white;
  padding: 0px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0;
  animation: fadeIn 0.5s forwards;
}

/* Efecto de aparición */
@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

.photo-card:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

/* Imagen */
.photo {
  width: 90px;
  height: 90px;
  border-radius: 8px;
  object-fit: cover;
  transition: opacity 0.5s ease-in-out;
  cursor: pointer;
}

.photo:hover {
  opacity: 0.8;
}

.eliminar-btn {
  position: absolute;
  top: 120px;
  right: 10px;
  background-color: red;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
}

.eliminar-btn:hover {
  background-color: darkred;
}

@media (max-width: 480px) {
  .container {
    margin-top: 150px;
  }
  .eliminar-btn {
  position: absolute;
  top: 90px;}
}




/* Estilo para el modal */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* Contenido del modal */
.modal-content {
  position: relative;
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 60%; /* Tamaño más pequeño del modal */
  max-width: 600px; /* Limita el tamaño máximo */
  max-height: 80vh; /* Para que no ocupe toda la altura de la pantalla */
  text-align: center;
  overflow: hidden;
}

/* Imagen en el modal */
.foto-modal {
  width: 100%;
  height: auto;
  max-height: 500px; /* Limita la altura de la imagen */
  object-fit: contain;
  border-radius: 8px;
}

/* Botones para navegar entre fotos */
.prev, .next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 24px;
  color: white;
  background-color: rgba(0, 0, 0, 0.5);
  border: none;
  padding: 10px;
  cursor: pointer;
}

.prev {
  left: 10px;
}

.next {
  right: 10px;
}

/* Cerrar el modal */
.close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 30px;
  color: #fff;
  background: none;
  border: none;
  cursor: pointer;
}

.close:hover {
  color: red;
}

/* Ajustes para pantallas móviles */
@media screen and (max-width: 768px) {
  /* Hacer el modal más pequeño en pantallas móviles */
  .modal-content {
    width: 80%; /* Ajusta el tamaño del modal */
    max-width: 90%; /* Asegura que no se haga más grande que el 90% de la pantalla */
  }
  .eliminar-btn {
  position: absolute;
  top: 90px;}
  .foto-modal {
    max-height: 400px; /* Limita la altura de la imagen en dispositivos pequeños */
  }

  .prev, .next {
    font-size: 18px; /* Reducir el tamaño de los botones */
    padding: 8px; /* Reducir el padding */
  }

  .close {
    font-size: 24px; /* Reducir el tamaño del botón de cierre */
  }

}

/* Ajustes para pantallas muy pequeñas (como teléfonos muy compactos) */
@media screen and (max-width: 480px) {
  .modal-content {
    width: 90%; /* Aumenta el porcentaje para pantallas muy pequeñas */
    max-width: 95%; /* Asegura que no se haga más grande que el 95% de la pantalla */
  }
  .container {
 
 margin-top: -120px;

}

  .foto-modal {
    max-height: 350px; /* Limitar aún más la imagen */
  }

  .prev, .next {
    font-size: 16px; /* Reducir aún más el tamaño de los botones */
    padding: 6px; /* Reducir el padding */
  }

  .close {
    font-size: 22px; /* Reducir aún más el tamaño del botón de cierre */
  }
}





/* Estilo del botón de descarga en el modal */
.download-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 8px 12px;
  border-radius: 5px;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.download-btn:hover {
  background-color: rgba(0, 0, 0, 0.8);
}
</style>
